module.exports = __webpack_public_path__ + "static/media/cdab2db0-1eb1-4654-ad89-5a64b95eab50.de34213f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Fonts/cdab2db0-1eb1-4654-ad89-5a64b95eab50.svg
// module id = 82
// module chunks = 0